// Render a level description
import React from "react";
import LegacyLevel from "./LegacyLevel";

const LevelDescription = (props) => {
  return (
    <div>
      <h2>{props.level.name} member</h2>
      <p className="selector-nav-cost">{props.level.priceLabel}</p>
      {props.level.id == 1 && props.legacyMember === "true" && <LegacyLevel />}
      <div dangerouslySetInnerHTML={{ __html: props.level.description }}></div>
    </div>
  );
};
export default LevelDescription;
